// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__+SA2i","formControl":"addForm_formControl__CSQTM","list":"addForm_list__TptXB","btnWrpper":"addForm_btnWrpper__9fJGC"};